__turbopack_context__.v({
  "content_metadata": "HAMhEG_content_metadata",
  "content_metadata__follow_us": "HAMhEG_content_metadata__follow_us",
  "content_metadata__genre": "HAMhEG_content_metadata__genre",
  "content_metadata__genre_badges": "HAMhEG_content_metadata__genre_badges",
  "content_metadata__rating": "HAMhEG_content_metadata__rating",
  "content_metadata__share_this_video": "HAMhEG_content_metadata__share_this_video",
  "content_metadata__share_this_video__links": "HAMhEG_content_metadata__share_this_video__links",
  "content_metadata__share_this_video__links__embed_button": "HAMhEG_content_metadata__share_this_video__links__embed_button",
  "content_metadata__social_stuff": "HAMhEG_content_metadata__social_stuff",
  "content_metadata__sub_title": "HAMhEG_content_metadata__sub_title",
  "content_metadata__title": "HAMhEG_content_metadata__title",
  "share_button": "HAMhEG_share_button",
});
